/* ==========================================================
   NUTRI PEAK - custom scripts
   Loaded site-wide from layout/theme.liquid.
   ========================================================== */
(function () {
  'use strict';

  /* ---------- Icon sharpening ----------
     The Zeal icon-with-text section asks the Shopify CDN for its icons at
     width=35 regardless of how large they actually render (76-84px), so they
     arrive soft. Strip the responsive attributes and request a size that
     covers a 3x device pixel ratio phone as well as desktop retina.

     84px CSS * 3 (densest phones) = 252 device px, so 360 gives headroom.
     Source files are 512px square, so nothing is being upscaled. */
  var TARGET_WIDTH = 360;

  function sharpenIcons() {
    document.querySelectorAll('.icwt-title-icon').forEach(function (img) {
      if (img.dataset.npSharp) return;
      img.dataset.npSharp = '1';
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.setAttribute('loading', 'eager');
      img.setAttribute('decoding', 'sync');
      var src = img.getAttribute('src') || '';
      if (/([?&])width=\d+/.test(src)) {
        src = src.replace(/([?&])width=\d+/, '$1width=' + TARGET_WIDTH);
      } else {
        src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + TARGET_WIDTH;
      }
      img.setAttribute('src', src);
    });
  }

  function init() {
    sharpenIcons();
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  /* re-run when Shopify's theme editor re-renders a section */
  document.addEventListener('shopify:section:load', init);
})();
